import { InvoicingControlDtoModel } from "./InvoicingControlDtoModel";

export class SourceTableTypeDtoModel {
	Id: number;
	Name: string;
	Controls: InvoicingControlDtoModel[];
}